// src/components/NewHtmlComponentForm.js
import React, { useState } from "react";

/**
 * NewHtmlComponentForm
 * - Controlled textarea for raw HTML string
 * - onSubmit(htmlString): save only
 * - onSubmitAndPublish(htmlString): save + publish (parent wires publish)
 * - onCancel(): close form without saving
 */
export default function NewHtmlComponentForm({
                                                 initialHtml = "",
                                                 onSubmit,
                                                 // NEW props for 3-button footer
                                                 enablePublishButton = false,
                                                 onSubmitAndPublish,
                                                 onCancel,
                                                 error,
                                             }) {
    const [html, setHtml] = useState(initialHtml);
    const [localError, setLocalError] = useState("");

    const validate = () => {
        const trimmed = (html || "").trim();
        if (!trimmed) {
            const msg = "Please paste some HTML before saving this panel.";
            setLocalError(msg);
            return { ok: false, value: "" };
        }
        setLocalError("");
        return { ok: true, value: trimmed };
    };

    const handleSave = (e) => {
        e?.preventDefault?.();
        const { ok, value } = validate();
        if (!ok) return;
        onSubmit?.(value);
    };

    const handleSaveAndPublish = (e) => {
        e?.preventDefault?.();
        const { ok, value } = validate();
        if (!ok) return;
        onSubmitAndPublish?.(value);
    };

    return (
        <div className="new-component-form">
            <h1>HTML Component Form</h1>

            <label style={{ display: "block", marginBottom: 8 }}>
                <span>Paste HTML</span>
                <textarea
                    className="muulti-input"
                    rows={10}
                    value={html}
                    onChange={(e) => setHtml(e.target.value)}
                    placeholder="&lt;div&gt;Your embedded HTML here&lt;/div&gt;"
                    style={{ width: "100%", resize: "vertical" }}
                />
            </label>

            {(localError || error) && (
                <p style={{ color: "crimson", marginBottom: 12 }}>
                    {localError || error}
                </p>
            )}

            <div className="muulti-container-button-container">
                <button onClick={handleSave} className="muulti-button">
                    Save Panel
                </button>

                {enablePublishButton && (
                    <button onClick={handleSaveAndPublish} className="muulti-button">
                        Save Panel &amp; Publish
                    </button>
                )}

                <button type="button" onClick={onCancel} className="muulti-button">
                    Cancel
                </button>
            </div>
        </div>
    );
}
